/** @jsxImportSource @emotion/react */

import { Up, Down } from 'grommet-icons'
import { keyframes } from '@emotion/react'

import { INITIAL_DIAL_ANGLE } from 'hooks/useMoodPlot'

// WARNING
// "Unratate" the arrows by the invesrse of the INITIAL_DIAL_ANGLE, because the whole "rotator" is rotated by INITIAL_DIAL_ANGLE.

const moveUp = keyframes({
  '0%': { opacity: 0 },
  '2%': { transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, -25px)`, opacity: 0.55 },
  '3%': { transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, -25px)` },
  '50%': { transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, -50px)`, opacity: 0 },
  '100%': { opacity: 0 },
})

const moveDown = keyframes({
  '0%': { opacity: 0 },
  '2%': { transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, 25px)`, opacity: 0.55 },
  '3%': { transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, 25px)` },
  '50%': { transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, 50px)`, opacity: 0 },
  '100%': { opacity: 0 },
})

const idleUpArrowStyles = {
  transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, -25px)`,
  opacity: 0,
  animation: `${moveUp} 6s infinite 7.4s cubic-bezier(0.22, 1, 0.36, 1)`,
}
const idleDownArrowStyles = {
  transform: `rotate(-${INITIAL_DIAL_ANGLE}deg) translate(-12px, 25px)`,
  opacity: 0,
  animation: `${moveDown} 6s infinite 4s cubic-bezier(0.22, 1, 0.36, 1)`,
}

export default function KnobAnimatedArrows() {
  return (
    <>
      <Up color="white" css={idleUpArrowStyles} />
      <Down color="white" css={idleDownArrowStyles} />
    </>
  )
}
